<script setup>
import { defineProps, defineEmits, computed} from "vue";
import UtilMoney from "@/utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "parcela",
]);

const emits = defineEmits([
    "update:alteraParcela",
]);

//==================================================================//
//======================= Altera Parcela ===========================//
//==================================================================//

const alteraParcela = (update)=>{

    emits('update:alteraParcela',update);

};

//==================================================================//
//======================= Ao Expandir Lista ========================//
//==================================================================//

const aoExpandirLista = ()=>{

    alteraParcela({
        aberto: !props?.parcela?.aberto,
    })

};

//==================================================================//
//==================== Mostra Expandir Lista =======================//
//==================================================================//

let mostraExpandirLista = computed(()=>{

    if(props?.parcela?.lista?.length <= 0){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-tooltip
                    bottom
                >

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            v-show="mostraExpandirLista"
                            class="mx-2"
                            fab
                            dark
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoExpandirLista"
                        >

                            <v-icon
                                v-if="props?.parcela?.aberto == false"
                                dark
                            >
                                mdi-chevron-down
                            </v-icon>

                            <v-icon
                                v-else
                                dark
                            >
                                mdi-chevron-up
                            </v-icon>

                        
                        </v-btn>

                    </template>

                    <span>Visualizar os Recebimentos</span>

                </v-tooltip>

            </div>

        </div>

        <div class="c-table__cell c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    color="#dedede"
                    label
                    dark
                >

                    <v-icon left color="#565656">
                        mdi-receipt-text
                    </v-icon>

                    <span
                        class="c-table__cell-content-text"
                    >

                        {{props?.parcela?.codigo}}

                    </span>

                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.parcela?.sequencia}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.parcela?.tipo}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.parcela?.descricao}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.parcela?.parcelaDias}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.parcela?.dataVencimento}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.parcela?.dataPrevisao}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.parcela?.parcelaPorcentagem}}%

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                R$ {{UtilMoney.toBRL(props?.parcela?.valorOriginal)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                R$ {{UtilMoney.toBRL(props?.parcela?.valorRecebido)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                R$ {{UtilMoney.toBRL(props?.parcela?.valorParaReceber)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content"></div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #eeeeee;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__cell--principal{
    border-left: 10px solid #1976d2;
    border-radius: 5px;
}

.c-table__cell-content-text{
    color: #565656;
    font-weight: 600;
}

</style>
